export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7821.de0e07f9.jpg";